import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import { createPinia } from 'pinia' // 导入Pinia创建函数
const app = createApp(App)
const pinia = createPinia() // 创建Pinia实例
app.use(pinia) // 挂载到Vue应用
app.use(store)
app.use(router)
app.use(ElementPlus)
app.config.warnHandler = () => null
app.mount('#app')
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.directive('focus', {
  mounted(el) {
    // 针对 Element UI 的 el-input 组件
    const input = el.querySelector('input');
    const textarea = el.querySelector('textarea');
    input?.focus();
    textarea?.focus()
  }
});